import Vue from "vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import * as solidIcons from "@fortawesome/free-solid-svg-icons";
import * as regularIcons from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

Vue.component("font-awesome-icon", FontAwesomeIcon);

library.add(
  regularIcons.faSquare,
  regularIcons.faCheckSquare,
  regularIcons.faTrashAlt,
  regularIcons.faCircle,
  regularIcons.faCheckCircle,
  solidIcons.faCoffee,
  solidIcons.faInfoCircle,
);
